import {AfterViewInit, Component, HostListener, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import { ApprovalsModel } from "../../../models-otc/approvals-model";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import { catchError } from "rxjs/operators";
import dayjs from "dayjs";
import {range, throwError} from "rxjs";
import { Router } from "@angular/router";
import { OrdersService } from "../../../services-otc/orders.service";
import {ApproveOrderComponent} from "../../dialogs-otc/approve-order/approve-order.component";
import {RejectOrderComponent} from "../../dialogs-otc/reject-order/reject-order.component";
import {MatDialog} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {SearchOrdersService} from "../../../services-otc/search-orders.service";
import {NavBarComponent} from "../../../../nav-bar/nav-bar.component";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { FilterValue } from "../my-orders/my-orders.component";
import { FilterMyOrdersComponent } from "../../dialogs-otc/filter-my-orders/filter-my-orders.component";
import { Role } from "src/app/models/role";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD.MM.YYYY"
  },
  display: {
    dateInput: "DD.MM.YYYY",
    monthYearLabel: "DD.MM.YYYY",
    dateA11yLabel: "DD.MM.YYYY",
    monthYearA11yLabel: "DD.MM.YYYY"
  }
};

@Component({
    selector: "app-approvals",
    templateUrl: "./approvals.component.html",
    styleUrls: ["./approvals.component.css"],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ApprovalsComponent  implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator, { static: true }) paginatorApprovals: MatPaginator;

  filterApprovalsForm: FormGroup;

  approvalsList: ApprovalsModel[] = [];
  paginatedArray = [];

  approveStatusId = 1;
  rejectStatusId = 2;
  approvalOrderId:number;
  currentPage: number = 0;
  pageSize: number =  20;
  totalElements: number = 0;
  userRoles: Role[] = JSON.parse(sessionStorage.getItem('roles'));

  isNoItemsFound: boolean = false;
  isSmallBtnVisible: boolean = false;

  maxDate = new Date();

  protected readonly dayjs = dayjs;

  dateStringFormatting = "DD.MM.YYYY";
  placeholder: string = "-";
  searchValue: string;

  isFilterBtnVisible: boolean = false;
  filterResult: FilterValue = {
    startDate: '',
    endDate: '',
    searchValue: '',
    statusIds: [],
    clientIds: []
  };


  filterStartDate = new FormControl();
  filterEndDate  = new FormControl();
  constructor(
      private searchOrdersService: SearchOrdersService,
      private router: Router,
      private ordersService: OrdersService,
      private dialog: MatDialog,
      private fb: FormBuilder,
      public nav: NavBarComponent,
  ) {
        this.filterApprovalsForm = this.fb.group({
             filterStartDate: new FormControl(),
             filterEndDate: new FormControl(),
        });
  }

  ngOnInit(): void {
    if(sessionStorage.getItem('approvalsFilter') !== null) {
        this.filterResult = JSON.parse(sessionStorage.getItem('approvalsFilter'));
        this.searchValue = this.filterResult?.searchValue;
        this.hideShowFilterReset();
    }
    this.filterResult.forApprovals = true;
    this.populateApprovalsList();
    this.updateVisibility();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateVisibility();
  }
  updateVisibility() {
    this.isSmallBtnVisible = window.innerWidth < 1600; // Adjust the breakpoint as needed
  }
  searchOrders(){
    setTimeout(()=>{
      this.filterResult.searchValue = this.searchValue;
      sessionStorage.setItem('myOrdersFilter', JSON.stringify(this.filterResult));
      this.populateApprovalsList();
    },1200);
    this.hideShowFilterReset();
  }
  onPaginateChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.totalElements = event.length;
    this.populateApprovalsList();
  }
  populateApprovalsList(){
    this.nav.toggleLoading(true);

    this.isNoItemsFound = false;

    this.searchOrdersService.getApprovalList(
        this.currentPage,
        this.pageSize,
        this.searchValue?.trim()?.toLocaleLowerCase(),
        this.filterResult?.clientIds,
        this.filterResult?.startDate,
        this.filterResult?.endDate,
        this.filterResult?.statusIds
    )
        .subscribe(response => {
          if (response) {
            this.approvalsList = response.content;
            this.paginatedArray = response.content;
            this.isNoItemsFound = response.content.length > 0 ? false : true;
            setTimeout(()=> {
              this.nav.toggleLoading(false);
            },1200)
            this.totalElements = response.totalElements;
          } else {
            this.isNoItemsFound = true;
            setTimeout(()=> {
              this.nav.toggleLoading(false);
            },1200)
          }

        });

  }

  openApproveConfirmDialog(id: number) {
    this.approvalOrderId = id;
    const dialogRef = this.dialog.open(ApproveOrderComponent, {

    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.approveOrder();
      }
    });
  }

  openFilterDialog() {
    const dialogRef = this.dialog.open(FilterMyOrdersComponent, {
      data: {
        filterResult: this.filterResult
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.filterResult.startDate = result.startDate;
        this.filterResult.endDate = result.endDate;
        this.filterResult.clientIds = result.clientIds;
        this.filterResult.statusIds = result.statusIds;

        sessionStorage.setItem('approvalsFilter', JSON.stringify(this.filterResult));
      }
      this.populateApprovalsList();
      this.hideShowFilterReset();
    });
  }

  hideShowFilterReset(){
    this.isFilterBtnVisible = this.filterResult?.startDate?.length > 0 || this.filterResult?.endDate?.length > 0 || this.filterResult?.clientIds?.length > 0 || this.filterResult?.statusIds?.length > 0 || this.searchValue?.length > 0;
  }

  openRejectConfirmDialog(id:number) {
    this.approvalOrderId = id;
    const dialogRef = this.dialog.open(RejectOrderComponent, {

    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.rejectOrder();
      }
    });
  }


  reviewApproval(id:number){
    this.router.navigate([`/order-manager/order/${id}`, { origins: 'approvals' }]);
  }

  approveOrder() {

    this.ordersService
        .updateOrderApprovalStatus(this.approvalOrderId, this.approveStatusId)
        .pipe(
            catchError((error) => {
              console.error(error);
              return throwError(() => error);
            })
        )
        .subscribe(() => {
          this.refreshBrowser();
        });
  }

  rejectOrder() {
    this.ordersService
        .updateOrderApprovalStatus(this.approvalOrderId, this.rejectStatusId)
        .pipe(
            catchError((error) => {
              console.error(error);
              return throwError(() => error);
            })
        )
        .subscribe(() => {
          this.refreshBrowser();
        });

  }

  refreshBrowser() {
    sessionStorage.removeItem('approvalsFilter');
    // FORCE REFRESH BROWSER
    this.router.navigateByUrl("/order-manager/my-orders", { skipLocationChange: true }).then(() => {
      this.router.navigate(["/order-manager/approvals"]);
    });
  }

  resetApprovalList(){
    this.refreshBrowser();
  }

  ngAfterViewInit(): void {}
  protected readonly range = range;
}
